import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/core/shared/http.service';
import { SWAConfig } from '../../../project/shared/interfaces/swaconfig';
import { Observable, last } from 'rxjs';
import { WorkloadData } from '../interfaces/workloadData.interface';
import { AssignmentData } from '../interfaces/assignmentData.interface';
import { ChangelogAqFilter } from 'src/app/report/shared/interfaces/changelog-aq-filter.interface';
import { SpeedReportResponse } from 'src/app/report/shared/interfaces/speed-report-response.interface';
import { LogBaseFilter } from 'src/app/report/shared/interfaces/log-base-filter';

@Injectable({
  providedIn: 'root'
})

export class ReportService {
  constructor(private readonly httpService: HttpService) { }

  public getRouteStationUsageReport(): Observable<WorkloadData> {
    return this.httpService.get<WorkloadData>('Report/RouteStationUsageReport');
  }

  public getAssignedReport(): Observable<AssignmentData> {
    return this.httpService.get<AssignmentData>('Report/AssignedReport');
  }

  public getAQReport(filter: ChangelogAqFilter): Observable<any> {
    return this.httpService.post<any>('Report/AQReport', filter)
  }

  public getAQReportDownload(filter: ChangelogAqFilter): Observable<any> {
    return this.httpService.postBlob('Report/AQReport', filter)
  }

  public getRouteStationsSTMWithFilterNew(id: number, dateFrom: string, dateTo: string, deKanal: number): Observable<any> {
    return this.httpService.post<any>('Report/StmReport' + '?dekanal=' + deKanal, { from: dateFrom, to: dateTo, samId: id })
  }

  public getRouteStationsSTMWithFilterGraph(id: number, dateFrom: string, dateTo: string, deKanal: number): Observable<any> {
    return this.httpService.post<any>('Report/STM/Graph' + '?dekanal=' + deKanal, { from: dateFrom, to: dateTo, samId: id })
  }
  public getRouteStationsSTMWithFilterReport(id: number, dateFrom: string, dateTo: string, deChannels: any): Observable<any> {
    return this.httpService.post<any>('Report/STM/Report', { from: dateFrom, to: dateTo, samId: id, type: 'json', deChannels: deChannels })
  }

  public getRouteStationsSTMWithFilterReportDownload(id: number, dateFrom: string, dateTo: string, type: string, deChannels: any): Observable<any> {
    return this.httpService.postBlob('Report/STM/Report', { from: dateFrom, to: dateTo, samId: id, type: type, deChannels: deChannels })
  }

  public getRouteStationsCurrentWithFilterNew(id: number, dateFrom: string, dateTo: string): Observable<any> {
    return this.httpService.post<any>('Report/CurrentReport', { from: dateFrom, to: dateTo, samId: id })
  }

  public getRouteStationVoltageWithFilterNew(id: number, dateFrom: string, dateTo: string): Observable<any> {
    return this.httpService.post<any>('Report/VoltageReport', { from: dateFrom, to: dateTo, samId: id })
  }

  public getHeightControlReport(deviceFilter: LogBaseFilter): Observable<any> {
    return this.httpService.post<any>('Report/HeightControl/Report', deviceFilter)
  }

  public getHeightControlReportDownload(deviceFilter: LogBaseFilter): Observable<any> {
    return this.httpService.postBlob('Report/HeightControl/Report', deviceFilter)
  }

  public getRouteStationsSpeedNew(
    samId: number,
    from: string,
    to: string,
    minutes: number,
    type?: string,
    deChannel?: number
  ): Observable<any> {


    const finalType = type ? type : 'json';

    let body: any;
    if (deChannel) {
      body = { from, to, samId, type: finalType, minutes, deChannel };
    } else {
      body = { from, to, samId, type: finalType, minutes };
    }

    return this.httpService.post<any>('Report/SpeedReport', body);
  }

  public getRouteStationsSpeedNewDownload(samId: number, from: string, to: string, minutes: number, type: string, deKanal?: number): Observable<any> {

    let body: any;
    if (deKanal) {
      body = { from: from, to: to, samId: samId, type: type, minutes: minutes, deKanal };
    } else {
      body = { from: from, to: to, samId: samId, type: type, minutes: minutes };
    }
    return this.httpService.postBlob('Report/SpeedReport', body)
  }

  public getVoltageOverview(projectIds: number[]): Observable<any> {
    return this.httpService.post<any>('Report/VoltageDiagramm', { listOfProjectIds: projectIds })
  }

  public getRouteStationErrorOverview(): Observable<any> {
    return this.httpService.get<any>('Report/RouteStationErrorOverview')
  }

  public getFuelCellReport(from: string, to: string, type: string, samId: number, groupId: number, projectId?: number): Observable<any> {
    return this.httpService.post<any>('Report/FuelCellReport', { from: from, to: to, type: type, samId: samId, groupId: groupId, projectId: projectId })
  }

  public getFuelCellReportings(deviceFilter: LogBaseFilter): Observable<any> {
    return this.httpService.post<any>('Report/FuelCellReport', deviceFilter)
  }

  public getInterimsAQReportDeviceDownload(from: string, to: string, type: string, samId: number): Observable<any> {
    return this.httpService.postBlob('Report/AQ/device', { from: from, to: to, type: type, samId: samId })
  }

  public getInterimsAQReportDevice(from: string, to: string, samId: number): Observable<any> {
    return this.httpService.post('Report/AQ/device', { from: from, to: to, type: "json", samId: samId })
  }

}
